import { PizzaMenu } from './PizzaMenu';

export { PizzaMenu };
export default PizzaMenu;
